module.exports = __webpack_public_path__ + "static/media/tasklevel2.85f60eb6.png";